import React, { memo } from 'react';
import RequestInput from './RequestInput';
import { useSelector } from 'react-redux';
import moment from 'moment';
import useAuth from '../../../../hooks/useAuth';
import useDraftComment from '../../hooks/useDraftComment';

export const minutesLimit = 15;

function compareDateTime(dateTime, minutesLimit) {
    const inputDate = moment(dateTime).utc(); // Parse the input dateTime string using Moment.js
    const currentDate = moment().utc(); // Get the current date/time using Moment.js

    // Calculate the difference in minutes
    const diffInMinutes = currentDate.diff(inputDate, 'minutes');

    // Check if the difference is less than or equal to 15 minutes

    if (dateTime === null || dateTime === undefined || dateTime === '') {
        return true;
    }

    return diffInMinutes <= minutesLimit;
}

const RequestMessage = ({ roleArray, plan, label }) => {
    const { patientInfoComment } = useSelector((state) => state.requestComment);
    const auth = useAuth();
    const role = auth.user?.role;
    const noTimeLimit = compareDateTime(plan?.request_created_date, minutesLimit);
    const { draftRequestValue, isRequestUnsaved, getMessageLabel } = useDraftComment({
        currentPlanId: plan?.plan_id,
        planRequest: plan?.request,
    });

    return (
        <RequestInput
            // label={`${label} ${isRequestUnsaved ? '(unsaved)' : ''}`}
            label={getMessageLabel(label, isRequestUnsaved)}
            defaultValue={draftRequestValue}
            caseId={plan.case_id}
            planId={plan.plan_id}
            updatedDate={plan?.request_updated_date}
            createdDate={plan?.request_created_date}
            noTimeLimit={noTimeLimit}
            readOnly={
                roleArray.includes(role) &&
                ['PLAN_UPLOADED', 'CHANGE_REQUEST', 'UPGRADE_REQUEST'].includes(patientInfoComment?.case_status) &&
                !plan.approved_flag
                    ? false
                    : true
            }
        />
    );
};

export default memo(RequestMessage);
